import { PaymentMethod } from '../models/payment-method.model';

export class PaymentMethodUtils {
  public static isImojePaymentMethod(paymentMethod?: PaymentMethod | string) {
    return Object.keys(PaymentMethod).includes(paymentMethod);
  }

  public static isBillGatewayApp(paymentMethod?: PaymentMethod | string) {
    return !!paymentMethod && !this.isImojePaymentMethod(paymentMethod);
  }
}
